var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 10.248,
    y1: 3.733,
    x2: -3.712,
    y2: -0.897,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b31d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#2b31d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#2b31d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b31d9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M240.992,18.781a3.115,3.115,0,0,1-3.115-3.115V3.115a3.115,3.115,0,1,1,6.23,0V15.667A3.115,3.115,0,0,1,240.992,18.781Z",
    transform: "translate(-196.992)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M240.992,421.507a3.115,3.115,0,0,1-3.115-3.115V405.84a3.115,3.115,0,1,1,6.23,0v12.552A3.115,3.115,0,0,1,240.992,421.507Z",
    transform: "translate(-196.992 -333.507)",
    opacity: 0.52,
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M308.03,408.346a3.116,3.116,0,0,1-2.885-1.938L300.4,394.787a3.115,3.115,0,0,1,5.768-2.355l4.743,11.621a3.117,3.117,0,0,1-2.883,4.293Z",
    transform: "translate(-248.579 -323.378)",
    opacity: 0.58,
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M303.285,35.483A3.117,3.117,0,0,1,300.4,31.19l4.743-11.621a3.115,3.115,0,0,1,5.768,2.354l-4.743,11.621A3.116,3.116,0,0,1,303.285,35.483Z",
    transform: "translate(-248.578 -14.6)",
    opacity: 0.94,
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M151.092,408.346a3.117,3.117,0,0,1-2.883-4.293l4.743-11.621a3.115,3.115,0,0,1,5.768,2.354l-4.743,11.621A3.116,3.116,0,0,1,151.092,408.346Z",
    transform: "translate(-122.544 -323.378)",
    opacity: 0.46,
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M20.752,311.14a3.115,3.115,0,0,1-1.178-6L31.194,300.4a3.115,3.115,0,1,1,2.355,5.767l-11.621,4.743A3.1,3.1,0,0,1,20.752,311.14Z",
    transform: "translate(-14.604 -248.574)",
    opacity: 0.36,
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M393.613,158.95a3.115,3.115,0,0,1-1.178-6l11.621-4.743a3.115,3.115,0,1,1,2.355,5.767l-11.621,4.743A3.1,3.1,0,0,1,393.613,158.95Z",
    transform: "translate(-323.38 -122.542)",
    opacity: 0.82,
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M32.371,158.952a3.1,3.1,0,0,1-1.176-.232l-11.621-4.743a3.115,3.115,0,1,1,2.355-5.767l11.621,4.743a3.115,3.115,0,0,1-1.178,6Z",
    transform: "translate(-14.605 -122.544)",
    opacity: 0.24,
    fill: "url(#linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M405.232,311.146a3.1,3.1,0,0,1-1.176-.232l-11.621-4.743a3.115,3.115,0,1,1,2.355-5.767l11.621,4.743a3.115,3.115,0,0,1-1.178,6Z",
    transform: "translate(-323.38 -248.579)",
    opacity: 0.7,
    fill: "url(#linear-gradient)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M357.557,84.778a3.115,3.115,0,0,1-2.2-5.317l8.875-8.875a3.115,3.115,0,0,1,4.405,4.4l-8.875,8.875A3.1,3.1,0,0,1,357.557,84.778Z",
    transform: "translate(-293.523 -57.697)",
    opacity: 0.88,
    fill: "url(#linear-gradient)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M72.789,369.548a3.115,3.115,0,0,1-2.2-5.317l8.875-8.875a3.115,3.115,0,0,1,4.405,4.4l-8.875,8.875A3.106,3.106,0,0,1,72.789,369.548Z",
    transform: "translate(-57.699 -293.522)",
    opacity: 0.4,
    fill: "url(#linear-gradient)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M81.663,84.78a3.105,3.105,0,0,1-2.2-.912l-8.875-8.875a3.115,3.115,0,0,1,4.405-4.4l8.875,8.875a3.115,3.115,0,0,1-2.2,5.317Z",
    transform: "translate(-57.698 -57.699)",
    opacity: 0.18,
    fill: "url(#linear-gradient)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M366.433,369.55a3.105,3.105,0,0,1-2.2-.913l-8.875-8.875a3.115,3.115,0,0,1,4.405-4.4l8.875,8.875a3.115,3.115,0,0,1-2.2,5.317Z",
    transform: "translate(-293.523 -293.524)",
    opacity: 0.64,
    fill: "url(#linear-gradient)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M15.667,244.107H3.116a3.115,3.115,0,0,1,0-6.23H15.667a3.115,3.115,0,1,1,0,6.23Z",
    transform: "translate(-0.001 -196.992)",
    opacity: 0.3,
    fill: "url(#linear-gradient)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M418.392,244.107H405.84a3.115,3.115,0,1,1,0-6.23h12.552a3.115,3.115,0,1,1,0,6.23Z",
    transform: "translate(-333.507 -196.992)",
    opacity: 0.76,
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1ce7801b652d19bede44ebd40847d1ce.svg";
export { ForwardRef as ReactComponent };